import { render, staticRenderFns } from "./RoleSelection.vue?vue&type=template&id=3ee1368a&scoped=true&"
import script from "./RoleSelection.vue?vue&type=script&lang=js&"
export * from "./RoleSelection.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelection.vue?vue&type=style&index=0&id=3ee1368a&prod&scoped=true&lang=scss&"
import style1 from "./RoleSelection.vue?vue&type=style&index=1&id=3ee1368a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee1368a",
  null
  
)

export default component.exports